import { render, staticRenderFns } from "./formDocumentosStudiantesModal.vue?vue&type=template&id=3d44d66e&"
import script from "./formDocumentosStudiantesModal.vue?vue&type=script&lang=js&"
export * from "./formDocumentosStudiantesModal.vue?vue&type=script&lang=js&"
import style0 from "./formDocumentosStudiantesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports